import React from 'react';
import { useLocation } from 'react-router-dom';
import CreateIndigentForm from '../modules/Indigent/CreateIndigentForm';

const CreateIndigentPage: React.FC = () => {
    const location = useLocation();
    const prefillIndigent = (location.state as any)?.prefillIndigent;
    return <CreateIndigentForm key={prefillIndigent ? 'prefilled' : 'empty'} initialFormData={prefillIndigent} />;
};

export default CreateIndigentPage;
